import getWeatherForecastOperation from 'owa-service/lib/operation/getWeatherForecastOperation';
import getWeatherForecastRequest from 'owa-service/lib/factory/getWeatherForecastRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
export default function getWeatherForecastService(weatherLocationId, temperatureUnit) {
    return getWeatherForecastOperation({
        Header: getJsonRequestHeader(),
        Body: getWeatherForecastRequest({
            WeatherLocationIds: weatherLocationId,
            TemperatureUnit: temperatureUnit,
        }),
    }).then(function (response) {
        return response.Body;
    });
}
//# sourceMappingURL=getWeatherForecastService.js.map